import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { EntityAvatar, Tag } from '@/components';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/Tooltip';

interface DirectoryItemHeaderProps {
    icon: ReactNode;
    imageUrl?: string;
    title: string;
    badge?: ReactNode;
    tags?: string[];
    rightContent?: ReactNode;
    className?: string;
}

export function DirectoryItemHeader({
    icon,
    imageUrl,
    title,
    badge,
    tags,
    rightContent,
    className,
}: DirectoryItemHeaderProps) {
    return (
        <div
            className={cn(
                'relative h-[98px] w-full rounded-lg bg-grey-600',
                className,
            )}
        >
            <div className="flex h-full items-center gap-6 pl-6 pr-6">
                <EntityAvatar icon={icon} imageUrl={imageUrl} />

                <div
                    className={cn(
                        'flex min-w-0 flex-1 flex-col items-start gap-3',
                        rightContent && 'pr-[150px]',
                    )}
                >
                    <div className="flex w-fit max-w-full min-w-0 flex-row flex-wrap items-center gap-2.5">
                        <h1 className="min-w-0 max-w-full truncate text-lg-medium text-white-100">
                            {title}
                        </h1>
                        {badge}
                    </div>
                    {tags && tags.length > 0 && (
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <div className="flex max-h-[22px] w-full min-w-0 cursor-default flex-row flex-wrap items-center gap-1 overflow-hidden">
                                    {tags.map((tag, index) => (
                                        <Tag key={index}>{tag}</Tag>
                                    ))}
                                </div>
                            </TooltipTrigger>
                            <TooltipContent
                                side="top"
                                sideOffset={8}
                                className="flex max-w-[280px] flex-wrap gap-1"
                            >
                                {tags.map((tag, index) => (
                                    <Tag key={index}>{tag}</Tag>
                                ))}
                            </TooltipContent>
                        </Tooltip>
                    )}
                </div>

                {rightContent && (
                    <div className="absolute bottom-[33px] right-6">
                        {rightContent}
                    </div>
                )}
            </div>
        </div>
    );
}
